/**
 * Created by intellicar-rinas on 12/9/17.
 */
import React, { Component } from "react";
import "./MainLayout.css";
import InMap from "../components/InMap/InMap";
import Header from "../components/Header/Header";
import LoginForm from "../components/LoginForm/LoginForm";
import LeftPane from "../components/LeftPane/LeftPane";
import ReportWindow from "../components/ReportWindow/ReportWindow";
import InToast from "../components/InToast/InToast";
import InToast1 from "../components/InToast/InToast1";
import RightPane from "../components/RightPane/RightPane";
import LeftTree from "../components/LeftTree/LeftTree";
import RecentDevices from "../components/RecentDevices/RecentDevices";
import DynamicGeofence from "../components/DynamicGeofence/DynamicGeofence";
import CarAnimation from "../components/CarAnimation/CarAnimation";
import SettingsPane from "../components/SettingsPane/SettingsPane";
import Dtcpane from "../components/DtcReport/DtcPane";
import ImpersonateWindow from "../components/ImpersonateWindow/ImpersonateWindow";
//  import mixpanel from "mixpanel-browser";

import { get, save } from "../helpers/helperFunctions";
import { connect } from "react-redux";
import actions from "../store/actions";
import getStatsConfig from "./config/statsConfig";
import reportsConfig from "./config/reportsConfig";
import GeofenceAPIs from "../APIs/GeofenceAPIs";
import UserAPIs from "../APIs/UserAPIs";
import searchConfig from "../Layouts/config/searchConfig";
import _ from "lodash";
import { bulkReqTracker } from "../helpers/helperFunctions";
import IntAnalytics from "../IntAnalytics";
import { googleMapAPIKey } from "../constants/constants";
import { mergeGroup } from "../components/InMap/MQTT/MqttVehicleMap";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword";
import GroupsAPIs from "../APIs/GroupAPIs";
import ReportAPIs from "../APIs/ReportAPIs";
import SocTempFilter from "../components/SocTempFilter/SocTempFilter"
import NewInMapBucket from "../components/NewInMapBucket/NewInMapBucket";
import {isBlueSmart} from "../helpers/helperFunctions";

import getStatsConfigSocTemp from "./config/statsConfigSocTemp";
import BulkImmobWindow from "../components/BulkImmobilize/BulkImmobWindow";
import AmplusImmob from "../components/AmplusImmob/AmplusImmob";

let statsConfig = getStatsConfig();

let StatsConfigSocTemp = getStatsConfigSocTemp();

const dependencyAPIs = [
  "vehicleMap",
 //  "geofenceMap",
  "userInfo",
 //  "groupTree",
  "gotAllBuckets",
  "auth",
];
// const dependencyAPIs = ['vehicleMap'];

class AddressBox extends Component {
  state = {
    addr: ''
  }
  componentDidMount() {
    window.setAddrBox = (addr) => {
      this.setState({ addr });
    }
  }
  render() {
    let { addr } = this.state
    return addr ? <div className="ml-abx">
      <h4 className="ml-abx-desc">{addr}</h4></div> : null
  }
}
//  class CopyStatus extends Component {
//    constructor(props) {
//      super(props)
//      this.props = props
//    }
//  render() {
//    return(
//      <div className="copyLink">
//        <div className="linkBox"> 
//          <span className="title"><span>{this.props.errorMsg != null ? "Failed!!" : "Link Copied!"}</span></span>
//          <span className="content">{this.props.errorMsg != null ? this.props.errorMsg : "Link genarated." } </span>
//        </div>

//      </div>
//    )
//  }
// }
class MainLayout extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      disableRightPane: false,
      // copyLink: false,
      // copyError: null
    };

    this.sessionID = window.getSessionID();
    const auth = window.getAuth();
    if (Object.entries(auth).length>0) {
      IntAnalytics.authenticate({ username: auth.userinfo.username });
    }

   //       if (!auth) {
   //    props.dispatch({ type: actions.AUTH_FAILURE })
   //  } else {
   //    props.dispatch({ type: actions.AUTH_SUCCESS, data: auth })
   //  }

    console.log('%cAvailable Users [' +  1+ ']', 'font-weight:bold; color:blue')
   //  for (let idx in authList) {
   //    if (authList[idx]) {
   //      console.log('%c' + idx + ' : ' + authList[idx].userinfo.username + (idx == this.sessionID ? ' <' : ''), 'font-weight:bold; color:green')
   //    }
   //  }



    this.isAllDependencyAPIsLoaded = this.isAllDependencyAPIsLoaded.bind(this);
    this.isGoogleMapsLoaded = this.isGoogleMapsLoaded.bind(this);
    this.loadVehicleList = this.loadVehicleList.bind(this);
    this.loadUserInfo = this.loadUserInfo.bind(this);
    this.loadGroup = this.loadGroup.bind(this);
    this.loadDependencies = this.loadDependencies.bind(this);
    this.mergeVehicleWithGroup = this.mergeVehicleWithGroup.bind(this);
    this.mapLoaded = this.mapLoaded.bind(this);
    this.getStatsConfig = this.getStatsConfig.bind(this);
    window.initMap = this.mapLoaded;


    window.locations = {
      USR: { lat: 12.983468, lng: 77.5915803 },
      MUM: { lat: 19.195549, lng: 72.936381 },
      BLR: { lat: 12.983468, lng: 77.5915803 },
      HYD: { lat: 17.384125, lng: 78.479447 },
      PUN: { lat: 18.521445, lng: 73.866031 },
      DEL: { lat: 28.614132, lng: 77.215449 },
      CHE: { lat: 13.075837, lng: 80.206900 },
      KOL: { lat: 22.6754795, lng: 88.0877022 },
      JPR: { lat: 26.9124, lng: 75.7873 },
      LKO: {lat:26.852827154724768, lng:80.93942284537255},
      COK: {lat:9.930846189154385, lng:76.2674016386584}
    };

    const checkDep = () => {
      if (!this.isAllDependencyAPIsLoaded()) {
        setTimeout(checkDep)
      } else {
        console.log('All Dependencies Loaded');
        this.forceUpdate();
      }
    };

    this.depFailed = () => {
      this.props.dispatch({
        type: actions.AUTH_FAILURE,
      });
    };

    const mapLoaded = () => {
      if (!this.googleMapLoaded) {
        this.googleMapLoaded = true;
      }
    };

    const addMapLoadListener = () => {
      if (window.map) {
        window.map.addListener('idle', mapLoaded)
      } else {
        setTimeout(addMapLoadListener, 100);
      }
    };
    // window.copyStatus = (status,errmsg) => {
    //  this.setState({copyLink: status})
    //  if(errmsg){
    //    this.setState({copyError : errmsg})
    //  }
    // }
    addMapLoadListener();

  }

  isAuth = () => this.props.auth;

  onSignedOut=()=>{
     localStorage.clear();
     window.location.reload();
   
  }

  onSignedIn = () => {
   //  let impersonated = JSON.parse(window.IntellicarSSOWidget.default.getImpUserDetails());
   //  console.log("sso signed in", impersonated);
   //  if (impersonated) {
   //    impersonated.userinfo = JSON.parse(impersonated.userInfo)
   //  }
   //  let rootUser = JSON.parse(window.IntellicarSSOWidget.default.getRootUserDetails());
   //  if (rootUser) {
   //    rootUser.userinfo = JSON.parse(rootUser.userInfo)
   //  }


    let userInfo = JSON.parse(
     window.IntellicarSSOWidget.default.getImpUserDetails()
   );
   if (Object.entries(userInfo).length > 0) {
     userInfo.userinfo = JSON.parse(userInfo.userInfo);
     this.props.dispatch({
       type: actions.AUTH_SUCCESS,
       data: userInfo,
     });
     return
   } else {
     let userInfo = JSON.parse(
       window.IntellicarSSOWidget.default.getRootUserDetails()
     );
     userInfo.userinfo = JSON.parse(userInfo.userInfo);
     this.props.dispatch({
       type: actions.AUTH_SUCCESS,
       data: userInfo,
     });
   }

   //  save("auth", userInfo);
  }


  componentDidMount() {
    this.checkLoop = setInterval(() => {
      if (this.isAllDependencyAPIsLoaded()) {
       //  console.log('All Dep loaded');
        window.allDependenciesLoaded();
        this.forceUpdate();
        clearInterval(this.checkLoop);
      } else {
        this.forceUpdate();
      }
    }, 1000);

    window.IntellicarSSOWidget.default.renderProfileSettings("intellicarSSODropWidget",
      {
        onSignedIn: this.onSignedIn,
        onLoggedOut:this.onSignedOut 
      });
  }



  componentDidUpdate(props) {
    let impersonate = this.props.auth && this.props.auth.impPerm && !this.props.auth.skipImp;

    if (!props.auth && this.props.auth && !impersonate) {
      this.loadDependencies();
    }
  }

  componentWillReceiveProps(props) {
    if (!this.props.gotAllBuckets && props.gotAllBuckets) {
      window.vdsLoaded(window.vehicleMap)
    }
    let disableRightPane = false
    if (window.userInfo !== undefined) {
      disableRightPane = window.userInfo.SELF.disable_digital_twin;
      if (disableRightPane) {
        this.setState({ disableRightPane: true })
      }
    }
  }

  mapLoaded() {
    console.log('Maps Loaded');
    window.mapLoadedLibrary = true;
  }

  isGoogleMapsLoaded() {
    return window.google && window.google.maps && window.mapLoadedLibrary;
  }

  isUserInfoLoaded = () => {
    return this.props.userInfo;
  }

  isAllDependencyAPIsLoaded() {
    let loaded = true;
    for (let key in dependencyAPIs) {
      if (!this.props[dependencyAPIs[key]]) {
        loaded = false;
      }
    }
    return loaded && this.isGoogleMapsLoaded();
  }


  loadDependencies() {
    this.loadVehicleList();
    this.loadGeofenceList();
    this.loadUserInfo();
    this.loadGroup();
    this.loadEvGroups();
    if (!_.get(window, "google.maps"))
      loadJS(
        "https://maps.googleapis.com/maps/api/js?key=" +
        googleMapAPIKey +
        "&libraries=places,drawing,visualization&callback=initMap"
      );
  }

  loadEvGroups = () => {
    GroupsAPIs.getEVGroups().then(rsp => {
      window.evGroups = rsp.map(f => f.groupid);
      window.evGroupList = rsp;

      ReportAPIs.listGroupForSurgeReport().then((resp) => {
       window.surgeGroups = resp
      })
    }).catch(() => { })
  }

  loadGroup() {
    const handleSuccess = (resp) => {
      window.userGroups = resp;
      console.log("Groups Loaded");
      this.treeRaw = resp;
      this.treeRawMap = {};
      for (let idx in this.treeRaw) {
        this.treeRawMap[this.treeRaw[idx].groupid] = this.treeRaw[idx];
      }

      let patharr;
      for (let idx in this.treeRaw) {
        this.treeRaw[idx].groupnamepath = "";
        patharr = this.treeRaw[idx].path.split("/");
        for (let jdx in patharr) {
          if (this.treeRawMap[patharr[jdx]]) {
            this.treeRaw[idx].groupnamepath +=
              "/" + this.treeRawMap[patharr[jdx]].name;
          }
        }
      }
      window.treeRawMap = this.treeRawMap;
      this.mergeVehicleWithGroup();
    };

    const handleFailure = (resp) => {
      console.log(resp);
    };

    UserAPIs.getMyGroups({}).then(handleSuccess, handleFailure);
  }

  mergeVehicleWithGroup() {
    this.tree = mergeGroup(this.treeRaw, this.users);
    this.props.dispatch({
      type: actions.GROUP_TREE_UPDATE,
      data: this.tree,
    });
    this.props.dispatch({
      type: actions.CALCULATE_ALLOWED_VEHICLES,
      data: this.tree,
    });
  }

  loadUserInfo() {
    const handleSuccess = (resp) => {
      console.log("Users Loaded");
      let data = {};
      let usertype = "";
      for (let idx in resp) {
        try {
          data[resp[idx].tag] = JSON.parse(resp[idx].data);
        } catch (e) { }
        if (resp[idx].tag === "SELF") usertype = resp[idx].typename;
      }

      window.userInfo = data;

      this.props.dispatch({
        type: actions.USERINFO_UPDATED,
        data,
      });

      if (usertype)
        this.props.dispatch({
          type: "UPDATE_USERTYPE",
          data: usertype,
        });

      const setCenter = (latLng) => {
        if (this.googleMapLoaded) {
          //console.log("user latlng", latLng);
          window.map.setCenter(latLng);
        } else {
          setTimeout(() => setCenter(latLng), 100);
        }
      };

      setTimeout(() => {
        this.mergeVehicleWithGroup();
        if (this.props.userInfo && this.props.userInfo.SELF) {
          let userLatLng = (this.props.userInfo.SELF.latlng || "").split(",");
          if (userLatLng.length === 2) {
            window.locations.USR.lat = parseFloat(userLatLng[0]);
            window.locations.USR.lng = parseFloat(userLatLng[1]);
            setCenter(window.locations.USR);
          }
        }
      }, 500);
    };

    UserAPIs.getInfo({
      userid:
        this.props.auth && this.props.auth.userinfo
          ? this.props.auth.userinfo.userid
          : null,
    }).then(handleSuccess, this.depFailed);
  }

  loadGeofenceList() {
    const handleRespose = (resp) => {

      for (let idx in resp) {
        if (!resp[idx].status) {
         //  this.depFailed({});
         console.log("Geofence Loading Failed")
          return;
        }
      }

      console.log('Geofences Loaded');

      let data = resp.map(i => i.resp);
      let geofenceReports = data[0];
      geofenceReports.push(...data[1].filter(geo => geofenceReports.filter(geor => geo.geofenceid === geor.fenceid).length === 0));
      for (let idx in geofenceReports) {
        try {
          geofenceReports[idx].info = JSON.parse(geofenceReports[idx].geofencedata || geofenceReports[idx].info);
          geofenceReports[idx].name = geofenceReports[idx].name
        } catch (e) { }
      }
      this.props.dispatch({
        type: actions.GEOFENCE_MAP_UPDATED,
        data: { data: geofenceReports, reqTime: Date.now() }
      });
    };

    let body = { groupid: 1, geofencetype: 'all', recursive: 1 }
    let apiQ = [
      { api: GeofenceAPIs.getMyGeofenceReports, body, key: 'getMyGeofenceReports' },
      { api: GeofenceAPIs.getMyGeofences, body, key: 'getMyGeofence' },
    ]

    bulkReqTracker(apiQ, handleRespose);
    // GeofenceAPIs.getMyGeofenceReports()
    //     .then(handleSuccess, this.depFailed)
  }

  availableDevices = {};

  loadVehicleList() {

    const handleUserSuccess = resp => {
      this.users = resp;
      mergeUsers();
    };

    UserAPIs.getList({ groupid: 1, recursive: 1, usertype: 'all' })
      .then(handleUserSuccess, () => { console.log('User Fetching Failed') });

    window.vdsLoaded = (vehiclesMap) => {
      let vehicles = vehiclesMap
      //  console.log("vehicles from load vehicles",vehicles)
      let vehicleMap = {};
      let vehicleid;
      //     console.log("vle",vehicles)
      for (let idx in vehicles) {
        this.availableDevices[vehicles[idx].devicetype] = vehicles[idx].devicetype;
      }
      this.vehicles = vehiclesMap;
      mergeUsers();
    }
    const getValueFromObject = (data, keys, index = 0) => {
      let key = keys[index].trim();

      if (index === keys.length - 1) {
        return data[key] != null ? data[key] : '';
      }

      if (key.split('[]').length === 2) {
        key = key.replace('[]', '');
        let arr = [];
        for (let idx in data[key]) {
          arr.push(getValueFromObject(data[key][idx], keys, index + 1))
        }
        let a = arr.join();
        //    console.log("arr ",arr)
        return arr.join();
      }


      return getValueFromObject(data[key], keys, index + 1);
    };

    const mergeUsers = () => {
      if (this.users) {
        // if(window.map) {
        let userMap = {};

        for (let idx in this.users) {
          try {
            this.users[idx].meta = JSON.parse(this.users[idx].data);
          } catch (e) {
            this.users[idx].meta = { username: 'NA' };
          }
          this.users[idx].type = 'user';
          this.users[idx].id = this.users[idx].userid;
          this.users[idx].name = (this.users[idx].meta.username || 'NA') + '(' + this.users[idx].username + ')';
          // this.users[idx].stats = {};
          this.users[idx].deviceTypesList = [];
          this.users[idx].vehiclemeta = { model: 'user' };
          this.users[idx].devices = {};
          this.users[idx].vehicleno = this.users[idx].name;
          this.users[idx].singleSearchStr = this.users[idx].name;

          userMap['user_' + this.users[idx].userid] = this.users[idx];
        }

        setTimeout(() => {
          this.mergeVehicleWithGroup();
          let vehicleid;
          let vehicle;
          for (let idx in this.vehicles) {
            vehicle = this.vehicles[idx];
            vehicleid = vehicle.vehicleid;
            vehicle.groups = [];
            for (let jdx in vehicle.groupinfo) {
              if (vehicle.groupinfo[jdx] && this.treeRawMap && this.treeRawMap[vehicle.groupinfo[jdx][0]]) {
                vehicle.groups.push(this.treeRawMap[vehicle.groupinfo[jdx][0]]);
              }
            }

            vehicle.singleSearchStr = "";
            for (let jdx in searchConfig.singleSearch.preProcessValues) {
              vehicle[searchConfig.singleSearch.preProcessValues[jdx].to] =
                getValueFromObject(vehicle, searchConfig.singleSearch.preProcessValues[jdx].from.split('.'));
            }

          }


          // this.props.dispatch({
          //     type:actions.VEHICLE_MAP_UPDATED,
          //     data:{...(this.vehicles || {}), ...(userMap || {})}
          // });

        }, 100)
        // } else {
        //     setTimeout(mergeUsers, 2000);
        // }
      }
    }
  }

  basicStats = [
    'allvehicles', 'running', 'stopped', 'immobilized', 'mil',
    'nocomm',
    'nocomm-battery-low',
    'nocomm-others',
    'devicepullout',
    'immobpullout',
    'devicepullout-comm',
    'devicepullout-non-comm', 'rectification', 'panicButton',
    'never-comm-gps',
    'location-zero',
    'soc_1_25',
    'soc_25_50',
    'soc_50_75',
    'soc_75_100',
    'soc_100',
    'btt_1_15',
    'btt_15_30',
    'btt_30_45',
    'btt_a_45',
    'curentlycharging',
    'no_soc',
    'no_temp',
    'SOC_0',
    'SOC_NEG',
    'BTT_0',
    'BTT_NEG' ,
    'CLT_0',
    'CLT_1_15',
    'CLT_15_30',
    'CLT_30_45',
    'CLT_A_45',
    'CLT_NA',
    'CLT_NEG',
    'lock',
    'unlock'
  ]

  getStatsConfig(StatsConfig_data) {
   let hideAllBuckets = this.props.userInfo.SELF.hide_all_buckets
   let noncombucket = this.props.userInfo.SELF.new_nocomm_bucket
   if(hideAllBuckets) {
     return []
   }
   let isEv = this.isEVGroup()
   let removeStats = []
   if(isEv){
     //removing mil and currently charging for moeving
     if(window.gPath){
       for(let idx in window.gPath){
         if(window.gPath[idx].includes(2770)){
           removeStats.push('mil','curentlycharging')
         }
       }
     }
     //removing mil and currently charging for moeving
     this.basicStats = this.basicStats.filter(item => {
       if(!removeStats.includes(item)) {
         return item
       }
     })
   }
    if (this.tree) {

      let assetTrackerAvailable = false;
      let kleAvailable = false;

      for (let idx in this.availableDevices) {
        let devicetype = this.availableDevices[idx];
        if (devicetype == 'concox_assettracker' || devicetype == 'concox_at4') {
          assetTrackerAvailable = true;
        }
        if (devicetype == 'kle') {
          kleAvailable = true;
        }
      }

      if (kleAvailable) {
        this.basicStats.push('nocomm-kle');
      }

      if (assetTrackerAvailable) {
        this.basicStats.push('nocomm-assettracker');
      }
      if(noncombucket) {
       if(!this.basicStats.includes('nocomm_2')){
         let check = this.basicStats.indexOf('nocomm')
         if(check >-1)this.basicStats.splice(check,1)
         this.basicStats.push('nocomm_2')
         
       }
       }
      

      let userInfo = this.props.userInfo;
      let allowedStats = [...this.basicStats];
      let newStats = [];

      let parentGroupNames = this.tree.children.map(i => i.name);

      if (parentGroupNames.indexOf('zoomcar') !== -1) {
        allowedStats.push('badBatteryHealth');
        allowedStats.push('klenocomm');
      }

      if (parentGroupNames.indexOf('OlaTesting') !== -1) {
        allowedStats.push('badBatteryHealth');
      }

      if (parentGroupNames.indexOf('IntelliBLU') !== -1) {
        allowedStats.push('badBatteryHealth');
      }

      if (parentGroupNames.indexOf('ONN Bikes') !== -1 || (userInfo.SELF && userInfo.SELF.ui_custom_stats
        && userInfo.SELF.ui_custom_stats.indexOf('tampered') !== -1)) {
        allowedStats.push('tampered');
      }

      if ((parentGroupNames.indexOf('Orix') !== -1 || parentGroupNames.indexOf('wickedrideAT') !== -1 || parentGroupNames.indexOf('Driven') !== -1) ||
        (userInfo.SELF && userInfo.SELF.ui_custom_stats
          && userInfo.SELF.ui_custom_stats.indexOf('concox_assettracker_charging') !== -1)) {
        allowedStats.push('concox_assettracker_charging');
      }

      if ((userInfo.SELF && userInfo.SELF.ui_custom_stats
        && userInfo.SELF.ui_custom_stats.indexOf('users') !== -1)) {
        allowedStats.push('users', 'users_moving', 'users_stopped', 'users_charging');
      }

      if ((userInfo.SELF && userInfo.SELF.ui_custom_stats
        && userInfo.SELF.ui_custom_stats.indexOf('badBatteryHealth') !== -1)) {
        allowedStats.push('badBatteryHealth');
      }


      if (allowedStats.indexOf('badBatteryHealth')) {
        allowedStats.push('badBatteryHealth-bad', 'badBatteryHealth-avg', 'badBatteryHealth-good')
      }

      // if((userInfo.SELF && userInfo.SELF.ui_custom_stats 
      //     && userInfo.SELF.ui_custom_stats.indexOf('panicButton') !== -1))  {
      //     allowedStats.push('panicButton')
      // }
      if (parentGroupNames.indexOf('zoomcar') !== -1 || parentGroupNames.indexOf('EEE_TAXI') !== -1 || parentGroupNames.indexOf('Amplus') !== -1) {
         allowedStats.push('apiSubExpired')
      }

      for (let idx in StatsConfig_data) {
        if (allowedStats.indexOf(StatsConfig_data[idx].key) !== -1) {
          newStats.push(StatsConfig_data[idx]);
        }
      }

      return newStats;
    }
    return StatsConfig_data;
  }

  isEVGroup = () => {
    if (this.props.groupTree && this.props.groupTree.children) {
      const gTree = []
      const groups = this.props.groupTree.children;
      const gPath = [];
      for (let i in groups) {
        if (groups[i].path) {
          gTree.push(groups[i].path)
          gPath.push(gTree[i].split('/').filter(f => f).map(f => parseInt(f, 10)));
        }
      }
      window.gPath = gPath
      // path selection
      let evGroup = window.evGroups;
      for (let idx in gPath) {
        let groupPath = gPath[idx];
        for (let ndx in groupPath) {
          for (let ldx in evGroup) {
            if (groupPath[ndx] === evGroup[ldx]) {
              return true
            }
          }
        }
      }
    }
  }

  render() {
    let impersonate = this.props.auth && this.props.auth.impPerm && !this.props.auth.skipImp;

    let content;
    if (this.state.loading) {
      content = (
        <div className="ml-loading">
          Loading
        </div>
      )
    } else if (this.props.forgotPassword) {
      return <ForgotPassword />
    }


    else {
      this.loginPageMarked = false;
      content = (
        <div className="ml-sub">
          {
            this.isGoogleMapsLoaded() && this.isUserInfoLoaded() ? (
              <InMap statsConfig={this.getStatsConfig()} reports={reportsConfig} />
            ) : null
          }
          {
            this.isAllDependencyAPIsLoaded() ? (
              <div>
                <Header statsConfig={this.getStatsConfig(statsConfig)} />
                {this.isEVGroup() ?
                  <SocTempFilter statsConfig={this.getStatsConfig(StatsConfigSocTemp)} /> : null}
               {isBlueSmart(this.props) ?<NewInMapBucket statsConfig={this.getStatsConfig(StatsConfigSocTemp)}/> : null}
                <ReportWindow reports={reportsConfig} />
                {/* <InToast /> */}
                <InToast1 />
                <LeftPane statsConfig={this.getStatsConfig()} />
                <SettingsPane />
                <Dtcpane />
                {!this.state.disableRightPane && <RightPane />}
                <LeftTree />
                <RecentDevices />
                <DynamicGeofence />
                <AddressBox />
                {/* <AmplusImmob /> */}
                {this.props.bulkImmob && this.props.bulkImmob.active ? <BulkImmobWindow /> : null}
                {this.props.amplusImmob && this.props.amplusImmob.active ? <AmplusImmob /> : null}
                {/* {this.state.copyLink && <CopyStatus errorMsg = {this.state.copyError} />} */}
              </div>
            ) : (
              <CarAnimation center={true} />
            )
          }
        </div>
      )
    }
    return (
      <div className="MainLayout">
        {content}
        <div id="intellicarSSODropWidget"></div>
      </div>
    )
  }
}

function loadJS(src) {
  let ref = window.document.getElementsByTagName("script")[0];
  let script = window.document.createElement("script");
  script.src = src;
  script.async = true;
  ref.parentNode.insertBefore(script, ref);
}

const MapPropsToState = (state) => {
  let props = { auth: state.auth, forgotPassword: state.forgotPassword };
  props.groupTree = state.groupTree
  props.bulkImmob = state.bulkImmob
  props.amplusImmob = state.amplusImmob
  for (let key in dependencyAPIs) {
    props[dependencyAPIs[key]] = state[dependencyAPIs[key]];
  }
  return props;
};

export default connect(MapPropsToState)(MainLayout);
